export const ActionSetDrawer = ({ commit, state }) => {
  commit('SET_drawer', !state.drawer)
}

export const ActionSetDrawerFalse = ({ commit }) => {
  commit('SET_drawer', false)
}

export const ActionSetDrawerTrue = ({ commit }) => {
  commit('SET_drawer', true)
}
